import axiosClient from '@services/axiosClient';
import EndPoints from '@services/endpoints';
import { AxiosResponse } from 'axios';

import IPaginatedesponse from '@models/paginated-reponse';
import ISearchCriteria from '@models/dto/searchCriteria.dto';
import IPaginatedParams from '@models/paginated-params';
import IUserListItem from '../models/user-list-item';
import UserItemDto from '../models/dto/user-item.dto';
import UserItemDtoResponse from '../models/dto/user-item.response.dto';

export const getUsers = async (
  paginatedParams: IPaginatedParams,
  searchCriteria: ISearchCriteria,
): Promise<AxiosResponse<IPaginatedesponse<IUserListItem>>> => {
  return await axiosClient.post(
    EndPoints.user.getUsers(paginatedParams),
    searchCriteria,
  );
};

export const disableUserById = async (
  id: string,
): Promise<AxiosResponse<null>> => {
  return await axiosClient.put(EndPoints.user.disableUserById(id));
};

export const enableUserById = async (
  id: string,
): Promise<AxiosResponse<null>> => {
  return await axiosClient.put(EndPoints.user.enableUserById(id));
};

export const getUserById = async (
  id: string | undefined,
): Promise<AxiosResponse<UserItemDtoResponse>> => {
  return await axiosClient.get(EndPoints.user.getUserById(id));
};

export const editUserById = async (
  id: string | undefined,
  payload: Partial<UserItemDto>,
  userType: 'enterprise' | 'establishment',
): Promise<AxiosResponse<UserItemDto>> => {
  return await axiosClient.patch(
    EndPoints.user.editUserById(id, userType),
    payload,
  );
};

export const createUser = async (
  payload: UserItemDto,
  userType: 'enterprise' | 'establishment',
): Promise<AxiosResponse<null>> => {
  return await axiosClient.post(EndPoints.user.createUser(userType), payload);
};
